import { defineMessages } from 'react-intl';

const sharedMessages = defineMessages({
    basic: {
        id: 'src.Components.utils.sharedMessages.basic',
        defaultMessage: 'Ogólne',
    },
    address: {
        id: 'src.Components.utils.sharedMessages.address',
        defaultMessage: 'Adres',
    },
    phoneNumber: {
        id: 'src.Components.utils.sharedMessages.phoneNumber',
        defaultMessage: 'Numer telefonu',
    },
    parishPhoneNumber: {
        id: 'src.Components.utils.sharedMessages.parishPhoneNumber',
        defaultMessage: 'Numer telefonu parafii',
    },
    next: {
        id: 'src.Components.utils.sharedMessages.next',
        defaultMessage: 'Dalej',
    },
    back: {
        id: 'src.Components.utils.sharedMessages.back',
        defaultMessage: 'Wróć',
    },
    cancel: {
        id: 'src.Components.utils.sharedMessages.cancel',
        defaultMessage: 'Anuluj',
    },
    close: {
        id: 'src.Components.utils.sharedMessages.close',
        defaultMessage: 'Zamknij',
    },
    submit: {
        id: 'src.Components.utils.sharedMessages.submit',
        defaultMessage: 'Zatwierdź',
    },
    remove: {
        id: 'src.Components.utils.sharedMessages.remove',
        defaultMessage: 'Usuń',
    },
    generate: {
        id: 'src.Components.utils.sharedMessages.generate',
        defaultMessage: 'Generuj',
    },
    print: {
        id: 'src.Components.utils.sharedMessages.print',
        defaultMessage: 'Drukuj',
    },
    end: {
        id: 'src.Components.utils.sharedMessages.end',
        defaultMessage: 'Zakończ',
    },
    modalDescription: {
        id: 'src.Components.utils.sharedMessages.modalDescription',
        defaultMessage: 'Pamiętaj, że utracisz wszelkie wprowadzone informacje!',
    },
    aboutEntity: {
        id: 'src.Components.utils.sharedMessages.aboutEntity',
        defaultMessage: 'O grupie',
    },
    noEntity: {
        id: 'src.Components.utils.sharedMessages.noEntity',
        defaultMessage: 'Nie jesteś przypisany do żadnej grupy',
    },
    loading: {
        id: 'src.Components.utils.sharedMessages.loading',
        defaultMessage: 'Ładowanie...',
    },
    interactions: {
        id: 'src.Components.utils.sharedMessages.interactions',
        defaultMessage: 'Działania',
    },
    save: {
        id: 'src.Components.utils.sharedMessages.save',
        defaultMessage: 'Zapisz',
    },
    saveChanges: {
        id: 'src.Components.utils.sharedMessages.saveChanges',
        defaultMessage: 'Zapisz zmiany',
    },
    change: {
        id: 'src.Components.utils.sharedMessages.change',
        defaultMessage: 'Zmień',
    },
    email: {
        id: 'src.Components.utils.sharedMessages.email',
        defaultMessage: 'Email',
    },
    parishEmail: {
        id: 'src.Components.utils.sharedMessages.parishEmail',
        defaultMessage: 'Email parafii',
    },
    emailPlaceholder: {
        id: 'src.Components.utils.sharedMessages.emailPlaceholder',
        defaultMessage: 'Wprowadź adres email',
    },
    incorrectEmail: {
        id: 'src.Components.utils.sharedMessages.incorrectEmail',
        defaultMessage: 'Niepoprawny e-mail.',
    },
    select: {
        id: 'src.Components.utils.sharedMessages.select',
        defaultMessage: 'Wybierz',
    },
    add: {
        id: 'src.Components.utils.sharedMessages.add',
        defaultMessage: 'Dodaj',
    },
    title: {
        id: 'src.Components.utils.sharedMessages.title',
        defaultMessage: 'Tytuł',
    },
    titlePlaceholder: {
        id: 'src.Components.utils.sharedMessages.titlePlaceholder',
        defaultMessage: 'Miejsce na podanie tytułu',
    },
    yes: {
        id: 'src.Components.utils.sharedMessages.yes',
        defaultMessage: 'Tak',
    },
    no: {
        id: 'src.Components.utils.sharedMessages.no',
        defaultMessage: 'Nie',
    },
    nameAndSurname: {
        id: 'src.Components.utils.sharedMessages.name',
        defaultMessage: 'Imię i nazwisko',
    },
    pointsPerEvent: {
        id: 'src.Components.utils.sharedMessages.pointsPerEvent',
        defaultMessage: 'Punkty za obecność obowiązkową',
    },
    optionalPointsPerEvent: {
        id: 'src.Components.utils.sharedMessages.optionalPointsPerEvent',
        defaultMessage: 'Punkty za obecność nieobowiązkową',
    },
    pointsPerEventPlaceholder: {
        id: 'src.Components.utils.sharedMessages.pointsPerEventPlaceholder',
        defaultMessage: 'Wpisz ile obecni mają dostać punktów.',
    },
    invalidValue: {
        id: 'src.Components.utils.sharedMessages.invalidValue',
        defaultMessage: 'Niepoprawna wartość',
    },
    update: {
        id: 'src.Components.utils.sharedMessages.update',
        defaultMessage: 'Zaktualizuj',
    },
    irreversibleAction: {
        id: 'src.Components.utils.sharedMessages.irreversibleAction',
        defaultMessage: 'Ta operacja jest nieodwracalna!',
    },
    noEntitySelected: {
        id: 'src.Components.utils.sharedMessages.noEntitySelected',
        defaultMessage: 'Nie została wybrana żadna grupa.',
    },
    required: {
        id: 'src.Components.utils.sharedMessages.required',
        defaultMessage: 'Wymagany',
    },
    notRequired: {
        id: 'src.Components.utils.sharedMessages.notRequired',
        defaultMessage: 'Niewymagany',
    },
    role: {
        id: 'src.Components.utils.sharedMessages.role',
        defaultMessage: 'Rola',
    },
    edit: {
        id: 'src.Components.utils.sharedMessages.edit',
        defaultMessage: 'Edytuj',
    },
    people: {
        id: 'src.Components.utils.sharedMessages.people',
        defaultMessage: 'Ludzie',
    },
    addPerson: {
        id: 'src.Components.utils.sharedMessages.addPerson',
        defaultMessage: 'Dodaj osobę',
    },
    somethingWentWrong: {
        id: 'src.Components.utils.sharedMessages.somethingWentWrong',
        defaultMessage: 'Coś poszło nie tak. Spróbuj ponownie.',
    },
    allEntities: {
        id: 'src.Components.utils.sharedMessages.allEntities',
        defaultMessage: 'Wszystkie grupy',
    },
    subscription: {
        id: 'src.Components.utils.sharedMessages.subscription',
        defaultMessage: 'Subskrypcje',
    },
    settings: {
        id: 'src.Components.utils.sharedMessages.settings',
        defaultMessage: 'Ustawienia',
    },
    events: {
        id: 'src.Components.utils.sharedMessages.events',
        defaultMessage: 'Plan',
    },
    defaultPaymentMethod: {
        id: 'src.Components.utils.sharedMessages.defaultPaymentMethod',
        defaultMessage: 'Ustaw jako domyślną metodę płatności',
    },
    billingAddress: {
        id: 'src.Components.utils.sharedMessages.billingAddress',
        defaultMessage: 'Adres rozliczeniowy',
    },
    card: {
        id: 'src.Components.utils.sharedMessages.card',
        defaultMessage: 'Karta',
    },
    validUntil: {
        id: 'src.Components.utils.sharedMessages.validUntil',
        defaultMessage: 'Ważna do',
    },
    eventsDescription: {
        id: 'src.Components.utils.sharedMessages.eventsDescription',
        defaultMessage: 'Zarządzaj harmonogramem i przeglądaj nadchodzące wydarzenia parafialne.',
    },
    announcementsDescription: {
        id: 'src.Components.utils.sharedMessages.announcementsDescription',
        defaultMessage: 'Twórz i zarządzaj ogłoszeniami duszpasterskimi dla parafian.',
    },
    intentionsDescription: {
        id: 'src.Components.utils.sharedMessages.intentionsDescription',
        defaultMessage: 'Zarządzaj kalendarzem i przyjmuj intencje na msze święte.',
    },
    peopleInParishDescription: {
        id: 'src.Components.utils.sharedMessages.peopleInParishDescription',
        defaultMessage: 'Przeglądaj kartoteki, dodawaj nowych parafian i zarządzaj ich danymi.',
    },
    communitiesDescription: {
        id: 'src.Components.utils.sharedMessages.communitiesDescription',
        defaultMessage: 'Zarządzaj wspólnotami, grupami i organizacjami działającymi w parafii.',
    },
    eventsConfigDescription: {
        id: 'src.Components.utils.sharedMessages.eventsConfigDescription',
        defaultMessage: 'Konfiguruj typy, punkty i domyślne parametry dla wydarzeń.',
    },
    parishSettingsDescription: {
        id: 'src.Components.utils.sharedMessages.parishSettingsDescription',
        defaultMessage: 'Dostosuj podstawowe ustawienia, dane kontaktowe i informacje o parafii.',
    },
    subscriptionDescription: {
        id: 'src.Components.utils.sharedMessages.subscriptionDescription',
        defaultMessage: 'Zarządzaj planem, płatnościami oraz fakturami dla swojej parafii.',
    },
    helpDescription: {
        id: 'src.Components.utils.sharedMessages.helpDescription',
        defaultMessage: 'Znajdź odpowiedzi na najczęściej zadawane pytania lub skontaktuj się z obsługą.',
    },
    announcements: {
        id: 'src.Components.utils.sharedMessages.announcements',
        defaultMessage: 'Ogłoszenia parafialne',
    },
    intentions: {
        id: 'src.Components.utils.sharedMessages.intentions',
        defaultMessage: 'Intencje mszalne',
    },
    peopleInParish: {
        id: 'src.Components.utils.sharedMessages.peopleInParish',
        defaultMessage: 'Ludzie',
    },
    communities: {
        id: 'src.Components.utils.sharedMessages.communities',
        defaultMessage: 'Wspólnoty i grupy',
    },
    eventsConfig: {
        id: 'src.Components.utils.sharedMessages.eventsConfig',
        defaultMessage: 'Konfiguracja wydarzeń',
    },
    parishSettings: {
        id: 'src.Components.utils.sharedMessages.parishSettings',
        defaultMessage: 'Ustawienia',
    },
    help: {
        id: 'src.Components.utils.sharedMessages.help',
        defaultMessage: 'Pomoc',
    },
    parishTeam: {
        id: 'src.Components.utils.sharedMessages.parishTeam',
        defaultMessage: 'Kontakty parafialne',
    },
    parishTeamDescription: {
        id: 'src.Components.utils.sharedMessages.parishTeamDescription',
        defaultMessage: 'Zarządzaj kontaktami parafialnymi, ich rolami i danymi.',
    },
    addNewParishTeamContact: {
        id: 'src.Components.utils.sharedMessages.addNewParishTeamContact',
        defaultMessage: 'Dodaj nowy kontakt parafialny',
    },
    addNewParishTeamContactDescription: {
        id: 'src.Components.utils.sharedMessages.addNewParishTeamContactDescription',
        defaultMessage: 'Wprowadź dane nowego kontaktu parafialnego, przypisz mu rolę i zapisz.',
    },
    offers: {
        id: 'src.Components.utils.sharedMessages.offers',
        defaultMessage: 'Oferty',
    },
    offersDescription: {
        id: 'src.Components.utils.sharedMessages.offersDescription',
        defaultMessage: 'Zarządzaj ofertami parafialnymi, ich widocznością i szczegółami.',
    },
});

export default sharedMessages;
